import React from 'react';
import { BasicSpinner } from '../../../../../components';
import useTimestampButton from '../../../../../components/stopwatch/hooks/useTimestampButton';

export function ActiveCardTile({ userId, excludedWorkspaceIds, excludedOrganizationIds, onCardClick }) {
  const { tracked_card: activeCard, workspace_logo, loading } = useTimestampButton({
    userId,
    excludedWorkspaceIds,
    excludedOrganizationIds,
  });

  return (
    <div className="statistics-summary-tile statistics-summary-tile--span-2">
      <div className="statistics-summary-tile__label">Active Card</div>

      {loading && (
        <div className="d-flex justify-content-center py-2">
          <BasicSpinner />
        </div>
      )}

      {!loading && !activeCard && (
        <div className="statistics-summary-tile__empty">No active card</div>
      )}

      {!loading && activeCard && (
        <div className="active-card-tile" onClick={() => onCardClick(activeCard)}>
          {workspace_logo ? (
            <img
              className="active-card-tile__thumbnail"
              src={workspace_logo}
              alt=""
            />
          ) : (
            <div className="active-card-tile__thumbnail active-card-tile__thumbnail--placeholder" />
          )}

          <span className="active-card-tile__name">{activeCard.name}</span>

          <span className="active-card-tile__live-dot" title="Currently tracking" />
        </div>
      )}
    </div>
  );
}

export default ActiveCardTile;
